module.exports = "https://coursera_assets.s3.amazonaws.com/images/4e836d45a65c38aa6e3d84fe1d1c90af.jpg";